import posthog from "posthog-js";

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY!, {
  api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST,
  defaults: "2025-05-24",
});
